import { useState, useMemo } from 'react';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import InvoiceActionMenu from './InvoiceActionMenu';

interface Invoice {
  id: string;
  invoiceNumber: string;
  customerName: string;
  subscriptionType: string;
  inoviceDate: string;
  amount: string;
  dueDate: string;
  paymentStatus: string;
  paymentMethod: string;
}

interface InvoicesTableProps {
  invoices: Invoice[];
  setRefreshMode: (value: string) => void;
  filters: {
    startDate: Date | null;
    endDate: Date | null;
    customerName: string;
    subscriptionType: string;
    paymentStatus: string;
    paymentMethod: string,
  };
  onEdit: (invoice: Invoice) => void;
  onDelete: (invoice: Invoice) => void;
  onView: (invoice: Invoice) => void;
}

export default function InvoicesTable({ invoices, setRefreshMode, filters, onEdit, onDelete, onView }: InvoicesTableProps) {
  const filteredInvoices = useMemo(() => {
    let filtered = [...invoices, ...invoices, ...invoices, ...invoices, ...invoices, ...invoices,];

    // if (filters.search) {
    //   const searchTerm = filters.search.toLowerCase();
    //   filtered = filtered.filter(invoice => 
    //     invoice.invoiceNumber.toLowerCase().includes(searchTerm) ||
    //     invoice.customerName.toLowerCase().includes(searchTerm)  || 
    //     invoice.subscriptionType.toLowerCase().includes(searchTerm) ||
    //     invoice.amount.toLowerCase().includes(searchTerm) ||
    //     invoice.dueDate.toLowerCase().includes(searchTerm) ||
    //     invoice.paymentStatus.toLowerCase().includes(searchTerm) ||
    //     invoice.paymentMethod.toLowerCase().includes(searchTerm)
    //   );
    // }

    if (filters.customerName) {
      filtered = filtered.filter(invoice =>
        invoice.customerName === filters.customerName
      );
    }

    if (filters.subscriptionType) {
      filtered = filtered.filter(invoice =>
        invoice.subscriptionType === filters.subscriptionType
      );
    }

    if (filters.paymentMethod) {
      filtered = filtered.filter(invoice =>
        invoice.paymentMethod === filters.paymentMethod
      );
    }

    if (filters.paymentStatus) {
      filtered = filtered.filter(invoice =>
        invoice.paymentStatus === filters.paymentStatus
      );
    }

    if (filters.startDate && filters.endDate) {
      filtered = filtered.filter((invoice) => {
        const invoiceDate = new Date(invoice.inoviceDate);
        const startDate = filters.startDate;
        const endDate = filters.endDate;

        if (!startDate || !endDate) return true;

        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);

        return invoiceDate >= startDate && invoiceDate <= endDate;
      });
    }

    return filtered;
  }, [invoices, filters]);

  return (
    <div className="pb-3">

      <div className="sticky top-[100px] bg-black  pt-4">
        <div className="bg-[#2A2A2A] rounded-lg overflow-hidden">
          <table className="w-full table-fixed">
            <thead>
              <tr className="bg-[#1A1A1A] text-gray-400 text-sm">
                <th className="text-left p-4">Invoice Number</th>
                <th className="text-left p-4">Customer Name</th>
                <th className="text-left p-4">Subscription Type</th>
                <th className="text-left p-4">Invoice Date</th>
                <th className="text-left p-4">Amount</th>
                <th className="text-left p-4">Due Date</th>
                <th className="text-left p-4">Payment Status</th>
                <th className="text-left p-4">Payment Method</th>
                <th className="text-right p-4">Actions</th>
              </tr>
            </thead>
          </table>
        </div>
      </div>

      <div className="bg-[#2A2A2A] rounded-lg overflow-hidden">
        <table className="w-full table-fixed">
          <tbody>
            {filteredInvoices.map((invoice) => (
              <tr
                key={invoice.id}
                onClick={() => onView(invoice)}
                className="border-b border-white/[0.08] hover:bg-[#3a3a3a33] cursor-pointer"
              >
                <td className="p-4 text-gray-400">{invoice.invoiceNumber}</td>
                <td className="p-4 text-gray-400">{invoice.customerName}</td>
                <td className="p-4 text-gray-400">{invoice.subscriptionType}</td>
                <td className="p-4 text-gray-400">{invoice.inoviceDate}</td>
                <td className="p-4 text-gray-400">{invoice.amount}</td>
                <td className="p-4 text-gray-400">{invoice.dueDate}</td>
                <td className="p-4">
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium
                      ${invoice.paymentStatus === 'Paid' ? 'bg-[#1C3829] text-[#4ADE80]' :
                        invoice.paymentStatus === 'Due' ? 'bg-[#e1a01d6b] text-[#fff]' :
                          'bg-[#7F1D1D] text-red-500'
                      }`}
                  >
                    {invoice.paymentStatus}
                  </span>
                </td>
                <td className="p-4 text-gray-400">{invoice.paymentMethod}</td>
                <td className="p-4">
                  <div className="flex items-center justify-end gap-2" onClick={(e) => e.stopPropagation()}>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onEdit(invoice);
                      }}
                      className="p-2 hover:bg-[#3a3a3a33] rounded-lg text-gray-400 hover:text-white"
                    >
                      <FiEdit2 className="w-4 h-4" />
                    </button>
                    {/* <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onDelete(invoice);
                      }}
                      className="p-2 hover:bg-[#3a3a3a33] rounded-lg text-red-400 hover:text-red-300"
                    >
                      <FiTrash2 className="w-4 h-4" />
                    </button> */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
} 